// Translated sentences with inline formatting. Keeping "Use <0>{name}</0>'s
// saved logo" whole lets Spanish put the words in its own order:
//
//   trRich("Use <0>{name}</0>'s saved logo", { name }, [<strong />])
//
// <0>…</0> is the matching element from the list. <0/> is one with no
// content, such as <br />. Kept apart from i18n.js because it needs React.

import { cloneElement, createElement, Fragment } from "react";
import { parseRich, tr } from "./i18n.js";

function renderNode(node, elements, vars, key) {
  if (typeof node === "string") {
    return createElement(Fragment, { key }, tr(node, vars || {}));
  }
  const el = elements[node.index];
  if (!el) return null;
  const inner = node.children.map((c, i) => renderNode(c, elements, vars, i));
  return inner.length
    ? cloneElement(el, { key }, ...inner)
    : cloneElement(el, { key });
}

export function trRich(english, vars, elements) {
  // tr() with no values returns the translated template untouched; the
  // values go in after parsing so their content can't look like tags.
  const template = tr(english);
  return parseRich(template).map((node, i) =>
    renderNode(node, elements || [], vars, i),
  );
}
